import styled from 'styled-components';

export const HorizontalCard = styled.div`
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 #00000029;
  margin: 16px 16px;
  background: #fff;
  flex-basis: 20%;
  min-width: ${(props) => (props.browse ? 'auto' : '224px')};
  max-width: ${(props) => (props.browse ? 'auto' : '224px')};
  cursor: pointer;
  min-height: ${(props) => (props.card ? '346px' : '0')};

  @media (max-width: 720px) {
    flex-basis: 46%;
    margin: 0 8px 12px;
    cursor: default;
    min-width: ${(props) => props.width};
  }
`;

export const ProductCardPrice = styled.div`
  padding: 0px 7px 6px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .button {
    font-size: 14px;
    font-weight: 500;
    color: #ef4e5e;
    border: 1px solid #ef4e5e;
    height: 28px;
    line-height: 26px;
    text-align: center;
    border-radius: 5px;
    margin: auto 0 6px;
    &:hover {
      background: #f2f2f2bf;
    }
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }
  .goToCartButton {
    font-size: 14px;
    font-weight: 500;
    background-color: #ef4e5e;
    color: #fff;
    height: 28px;
    line-height: 26px;
    text-align: center;
    border-radius: 5px;
    margin: 0 0 6px;
    border: 1px solid #ef4e5e;
    &:hover {
      background-color: #ef4e5ee0;
    }
    @media (min-width: 720px) {
      cursor: pointer;
    }
  }

  h4,
  .product_name {
    font-size: 14px;
    color: hsl(0deg 0% 0% / 87%);
    overflow: hidden;
    padding: 9px 0 0;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: ${(props) => (props.DoubleGrid ? '1' : '2')};
    -webkit-box-orient: vertical;
    margin: 0;
    text-align: ${(props) => (props.DoubleGrid ? 'center' : 'left')};
    font-weight: 500;
    height: ${(props) => (props.DoubleGrid ? '25px' : '42.6px')};
  }
`;
export const Rating = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.category ? '10px 0' : '4px 0 16px')};

  & span {
    font-size: ${(props) =>
      props.DoubleGrid
        ? 'clamp(12px,2vw,13px)'
        : props.category
          ? 'clamp(12px,2vw,13px)'
          : props.ovulation
            ? 'clamp(10px,2vw,12px)'
            : '13px'};
    color: hsl(0deg, 0%, 0%, 78%);
    padding-right: 4px;
    font-weight: 500;
  }
  & img {
    width: clamp(15px, 2vw, 18px);
    height: clamp(15px, 2vw, 18px);
    margin-right: 4px;
  }

  .total_ratingnumber {
    color: #9d9d9d;
    font-size: clamp(10px, 2vw, 13px);
    font-weight: 500;
  }
`;

export const HorizontalFlex = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
export const ProductPrice = styled.div`
  display: flex;
  align-items: baseline;
  padding: 8px 0 8px;
  justify-content: ${(props) => (props.DoubleGrid ? 'center' : 'flex-start')};
  & .totalAmount {
    font-weight: 500;
    font-size: ${(props) =>
      props.DoubleGrid ? 'clamp(16px,2vw,18px)' : '18px'};
    color: hsla(0, 0%, 0%, 0.87);
  }

  .uaeAmountPrice {
    font-weight: 500;
    font-size: clamp(14px, 2vw, 16px);
    color: hsla(0, 0%, 0%, 0.87);
  }
  & .strikePrice {
    color: #9d9d9d;
    font-size: ${(props) =>
      props.DoubleGrid ? 'clamp(12px,2vw,13px)' : '13px'};
    text-decoration: line-through;
    font-weight: 500;
    padding-left: 6px;
  }
  .uaeStrikePrice {
    color: #9d9d9d;
    font-size: clamp(12px, 2vw, 13px);
    text-decoration: line-through;
    font-weight: 500;
    padding-left: 6px;
  }
  & .discount {
    font-size: ${(props) => (props.DoubleGrid ? '9px' : '12px')};
    color: #63b0a8;
    text-decoration: none;
    font-weight: 600;
    padding-left: 6px;
  }
`;
export const IdealForText = styled.p`
  font-size: 11px;
  font-weight: bold;
  margin-top: 6px;
  text-align: center;
  color: #929090;
`;
